import YoutubeVideoPlayer from "./YoutubeVideoPlayer";
import config from "../app.json";
import FieldText from "./Fields/FieldText";
import { Row, Col } from "react-bootstrap";
import React, { useState } from "react";
import ModalComponent from "./ModalComponent";
import "../Assets/Css/index.scss";

import ExternalLinkIcon from "../Assets/Images/external-link1.png"

const AwsConnection = (props) => {
  const { awsKeyId, setAwsKeyId, awsSecretKey, setAwsSecretKey } = props;
  const [showLearnVideo, setShowLearnVideo] = useState(false);

  const handleShowVideo = () => {
    setShowLearnVideo(true);
  };
  return (
    <div>
      <ModalComponent
        data={<YoutubeVideoPlayer videoId={config.YoutubeVideo} />}
        modalIsOpen={showLearnVideo}
        setModalIsOpen={setShowLearnVideo}
      />
      <h2>AWS Connection</h2>
      <span className="learn-link mb-4" onClick={handleShowVideo}><img src={ExternalLinkIcon} />{`Learn how to do it. ;)`}</span>
      <Row>
        <Col md={12}>
          <FieldText
            label="Your AWS Access key ID"
            type="text"
            onChange={(x) => setAwsKeyId(x.target.value)}
            placeholder="Enter user's access key ID"
            value={awsKeyId}
            required={true}
          />
        </Col>
        
      </Row>
      <Row>
        <Col md={12}>
          <FieldText
            label="Your AWS Secret access key"
            type="text"
            onChange={(x) => setAwsSecretKey(x.target.value)}
            placeholder="Enter user's secret access key"
            value={awsSecretKey}
            required={true}
          />
        </Col>
      </Row>
    </div>
  );
};
export default AwsConnection;
